import {createFeatureSelector, createSelector} from '@ngrx/store';
import {IStockHistoryState} from './stock-history.reducer';
import {IStockHistoryEvent} from '../models/stock-history-interfaces';

export const selectStockHistoryState = createFeatureSelector<IStockHistoryState>('stock-history');

export const selectStockHistoryEvents = createSelector(
  selectStockHistoryState,
  (state: IStockHistoryState): IStockHistoryEvent[] => state?.events,
);

export const selectStockHistoryIsLoading = createSelector(
  selectStockHistoryState,
  (state: IStockHistoryState): boolean => state.isLoading,
);

export const selectStockHistoryIsModalOpen = createSelector(
  selectStockHistoryState,
  (state: IStockHistoryState): boolean => state.isModalOpen,
);

export const selectStockHistoryItemCodes = createSelector(
  selectStockHistoryState,
  (state: IStockHistoryState): string[] => state.itemCodes,
);

export const selectStockHistoryItemOrigins = createSelector(
  selectStockHistoryState,
  (state: IStockHistoryState) => state.itemOrigins,
);

export const selectStockHistorySelectedField = createSelector(
  selectStockHistoryState,
  (state: IStockHistoryState): string => state.selectedField,
);

export const selectStockHistoryHasMore = createSelector(
  selectStockHistoryState,
  (state: IStockHistoryState): boolean => state.hasMore,
);


export const selectStockHistoryCurrentStoreId = createSelector(
  selectStockHistoryState,
  (state: IStockHistoryState): string => state.currentStoreId,
);

export const selectStockHistoryLastDocumentId = createSelector(
  selectStockHistoryState,
  (state: IStockHistoryState): string => state.lastDocumentId,
);

export const selectStockHistoryIsFullyLoaded = createSelector(
  selectStockHistoryState,
  (state: IStockHistoryState): boolean => !state.hasMore && !state.isLoading,
);
